











import { Prop, Component, Vue, Watch } from 'vue-property-decorator';

@Component({
    name: 'notification',
})
export default class Notification extends Vue {
    @Prop(String) public readonly message!: string;
    @Prop(Boolean) public readonly hasCloseButton!: boolean;

    public isVisible: boolean = false;

    public closeNotification() {
        this.isVisible = false;
    }

    public get hasMessage(): boolean {
        return this.message.length > 0;
    }

    @Watch('message')
    public messageWatcher(newVal: string) {
        if (newVal) {
            this.isVisible = true;
        }
    }
}
